/**
 * @description
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

export interface IInput {
    resource_id: number;
    url: string;
}

export interface IOutput {
    task_id: number;
}

export const pptToImg = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PPT_TO_IMG, data)
        .then((res: IResponse<IOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'pptToImg',
                props: data,
                additionalInfo: {
                    description: 'pptToImg fetchData error',
                },
            });
            throw err;
        });
};

export const pptToImgSync = fetchDataSync<IInput>(pptToImg);
